// extracted by mini-css-extract-plugin
export default {"divMain":"DivForm_divMain__2+gO6"};